import Image from 'next/image';
import Link from 'next/link';

import ArrowLeftIcon from '@/fo/icons/base/icons/arrow.svg';

import { styles } from './UiCartInformerAdditional.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface UiCartInformerAdditionalProps {
  children?: React.ReactNode;
  onClick?: NativeElement['onClick'];
  image?: string;
  href?: string;
  action?: string;
  title: React.ReactNode;
  variant?: 'base' | 'rounded';
  className?: string;
  target?: boolean;
}

export function UiCartInformerAdditional({
  image,
  title,
  action,
  href,
  variant = 'base',
  className,
  target,
  onClick
}: UiCartInformerAdditionalProps) {
  const slots = styles();

  const Action = href ? Link : 'button';

  return (
    <div
      className={slots.base({ rounded: variant === 'rounded', className })}
      onClick={onClick}
    >
      {image && (
        <Image
          className={slots.image()}
          src={image}
          width={84}
          height={84}
          alt={''}
        />
      )}
      <div>
        {title}
        {action && (
          <Action
            className={slots.link()}
            href={href || ''}
            type="button"
            target={target ? '_blank' : '_self'}
          >
            {action}
            <ArrowLeftIcon className={slots.arrow()} />
          </Action>
        )}
      </div>
    </div>
  );
}
